import { render, staticRenderFns } from "./DualIpad.vue?vue&type=template&id=42c0de59&"
import script from "./DualIpad.vue?vue&type=script&lang=js&"
export * from "./DualIpad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports